module.exports = __webpack_public_path__ + "img/W-S14.37bd2410.jpg";